import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Select from "react-select";
import moment from "moment";

const ProductRequestForm = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      overflow: "hidden",
      width: "140px",
      height: "20p",
      margin: "3px",
    }),
    dropdownContainer: (base, state) => ({
      ...base,
      gridTemplateRows: "0 min-content",
    }),
  };
  const frmRef = useRef({});
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [wareHouseData, setWareHouseData] = useState([]);
  const [warehouseId, setWarehouseId] = useState(0);
  const [unitsData, setUnitsData] = useState();
  const [itemSubType, setItemSubType] = useState();
  const [products, setProducts] = useState();

  const [selectedSubType, setSelectedSubType] = useState();
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectionSubType, setSelectionSubType] = useState([]);
  const [selectionProduct, setSelectionProduct] = useState([]);
  const [selectionUnit, setSelectionUnit] = useState([]);
  const [filterProducts, setFilterProducts] = useState();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const productRef = useRef({});

  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "500px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?orgId=${localStorage.getItem(
          "orgId"
        )}&useCase=Sales`,
      },
      (data) => {
        //console.log(data);
        var emplist = data.output;

        setEmployeeData(emplist);
      }
    );
  }, []);

  const { sendRequest: getWarehouseData } = useHttp();
  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setWareHouseData(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setUnitsData(res);
        }
      }
    );
  }, [getunits]);

  const { sendRequest: getSubItem } = useHttp();

  useEffect(() => {
    getSubItem(
      {
        url: `/api/productsubitem/`,
      },
      (res) => {
        if (res) {
          setItemSubType(res);
        }
      }
    );
  }, [getSubItem]);

  useEffect(() => {
    setSelectionSubType(
      itemSubType &&
        itemSubType.map((x) => ({
          value: x.productSubTypeId,
          label: x.productSubTypeName,
        }))
    );
  }, [itemSubType]);

  const { sendRequest: getProducts } = useHttp();

  useEffect(() => {
    getProducts(
      {
        url: `/api/product/`,
      },
      (res) => {
        if (res) {
          setProducts(res);
        }
      }
    );
  }, [getProducts]);

  const handleSubTypeChange = (option) => {
    setSelectedSubType(option);
    setSelectedProduct([]);
    setSelectedUnit([]);
  };

  useEffect(
    (e) => {
      const filteredProData =
        products &&
        products.filter(
          (item) =>
            parseInt(item.productSubTypeId) ===
            parseInt(selectedSubType && selectedSubType.value)
        );

      setFilterProducts(filteredProData);

      setSelectionProduct(
        filteredProData &&
          filteredProData.map((x) => ({
            value: x.productId,
            label: x.productName,
          }))
      );
    },
    [selectedSubType]
  );

  const handleProdcutChange = (option) => {
    if (option) {
      setSelectedProduct(option);
      setSelectedUnit([]);
    }
  };

  useEffect(
    (e) => {
      if (selectedProduct) {
        const filteredUnitId =
          filterProducts &&
          filterProducts
            .filter(
              (item) =>
                parseInt(item.productId) ===
                parseInt(selectedProduct && selectedProduct.value)
            )
            .map((item) => item);

        if (selectedProduct.value) {
          const id = filteredUnitId && filteredUnitId[0].unitId; //unit id

          const filteredUnits =
            unitsData &&
            unitsData
              .filter(
                (item) => parseInt(item.unitId) === parseInt(id) //filter unit type id
              )
              .map((item) => item.unitTypeId);

          const TypeId = (filteredUnits && filteredUnits[0]) || 0;

          const uData =
            unitsData &&
            unitsData.filter(
              (item) => parseInt(item.unitTypeId) === parseInt(TypeId) //filter all units
            );

          // set unit data

          setSelectionUnit(
            uData &&
              uData.map((x) => ({
                value: x.unitId,
                label: x.unitName,
              }))
          );
        }
      }
    },
    [selectedProduct]
  );
  const handleUnitChange = (option) => {
    setSelectedUnit(option);
  };

  const submitProduct = (e) => {
    e.preventDefault();
    const productName = selectedProduct && selectedProduct.label;

    const itemSubTypeName = selectedSubType && selectedSubType.label;
    const quantity = productRef.current.quantity.value;

    const unit = selectedUnit && selectedUnit.label;

    if (!productName || !itemSubTypeName || !quantity || !unit) {
      toast.success("Please fill in all fields!");

      return;
    } else {
      const productName = selectedProduct && selectedProduct.label;
      const isDuplicate = productDetails.some(
        (product) => product.productName === productName
      );
      if (isDuplicate) {
        toast.success("Item already exists!");

        return;
      }
      setProductDetails((x) => [
        ...x,
        {
          productRequestDetailId: generateUniqueID(),
          productId: selectedProduct && selectedProduct.value,
          productName: selectedProduct && selectedProduct.label,

          productSubTypeName: selectedSubType && selectedSubType.label,
          productSubTypeId: selectedSubType && selectedSubType.value,
          quantity: productRef.current.quantity.value || 0,
          quantityBalance: productRef.current.quantity.value || 0,

          unitId: selectedUnit && selectedUnit.value,
          unitName: selectedUnit && selectedUnit.label,
        },
      ]);

      setSelectedUnit({});
      setSelectedProduct({});
      setSelectedSubType({});
      productRef.current.quantity.value = 0;
    }
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);
    //console.log(uniqueID);
    return uniqueID.toString();
  }

  const { sendRequest: postProductRequest } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      productRequest: [
        {
          productRequestId: generateUniqueID(),

          requestDate: moment(new Date().toISOString().slice(0, 10)).format(
            "DD/MM/YYYY"
          ),
          productRequirementDate: moment(
            frmRef.current.requirement_date.value
          ).format("DD/MM/YYYY"),
          warehouseId: warehouseId,
          fieldExecutiveId: employeeId,
          productRequestDetails: productDetails,
          createdDate: moment().format("DD/MM/YYYY"),
          note: frmRef.current.note.value,
        },
      ],
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
    };

    //console.log(data);

    postProductRequest(
      {
        url: "/api/productRequest/",
        method: "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success("Product Request Send successfully");
        props.addForm(false);
      }
    );
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Product Request Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Requirment Date"}</label>
                      <input
                        type={"date"}
                        id={"requirement_date"}
                        required
                        ref={(el) => (frmRef.current["requirement_date"] = el)}
                        className="form-control"
                        min={currentDate}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"executive_name"}>
                        {"Field Executive"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      
                      >
                        <option>Select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option key={x.userId} value={x.userId}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"warehouse_name"}>
                        {"Warehouse Name"}
                      </label>

                      <select
                        id="warehouse_name"
                        className="form-control"
                        ref={(el) => (frmRef.current["warehouse_name"] = el)}
                        required
                        value={warehouseId}
                        onChange={(e) => {
                          setWarehouseId(e.target.value);
                        }}
                       
                      >
                        <option>Select</option>
                        {wareHouseData &&
                          wareHouseData.map((x) => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {"Product Details"}
                      </label>
                      <br /> &nbsp; &nbsp; &nbsp; &nbsp;
                      <button
                        type="button"
                        id={"product_details"}
                        onClick={() => setIsModalOpen(true)}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"note"}>{"Note"}</label>
                      <input
                        type={"text"}
                        id={"note"}
                        required
                        ref={(el) => (frmRef.current["note"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

      {isModalOpen && (
        <Modal isOpen={isModalOpen} style={customModalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"itemType"}>Product Sub Type</label>

              <Select
                styles={customStyles}
                options={selectionSubType}
                value={selectedSubType}
                onChange={(option) => {
                  handleSubTypeChange(option);
                }}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemCategory"}>Product Name</label>

              <Select
                styles={customStyles}
                options={selectionProduct}
                value={selectedProduct}
                onChange={(option) => {
                  handleProdcutChange(option);
                }}
                required
              />
            </div>

            <div className="col-md-2">
              <label htmlFor={"itemDescription"}>Quantity</label>&nbsp;
              <input
                type={"number"}
                id={"quantity"}
                required
                ref={(el) => (productRef.current["quantity"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"itemUnitPrice"}>Unit</label>
              <Select
                styles={customStyles}
                options={selectionUnit}
                value={selectedUnit}
                onChange={(option) => {
                  handleUnitChange(option);
                }}
                required
              />
            </div>
            <div className="col-md-1">
              <br />
              &nbsp;
              <button className="btn btn-success" onClick={submitProduct}>
                +
              </button>
            </div>
          </div>

          <hr />
          <div className="row">
            <table className="table table-bordered table-responsivetext-center">
              <thead className="">
                <tr className="">
                  <th>Sr. No</th>
                  <th>Product Sub Type</th>
                  <th>Product Name</th>
                  <th>Quantity</th>
                  <th>Unit</th>

                  <th>Delete</th>
                </tr>
              </thead>

              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>

                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.quantity}</td>
                        <td>{itm.unitName}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <hr />

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails &&
                  productDetails.map((x) => (x["isSave"] = true));
                setIsModalOpen(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ProductRequestForm;
